<template>

  <div class="container-content" >
    <div v-if="loading" class="d-flex align-items-center justify-content-center" style="height: 100%;">
      <i class="el-icon-loading" style="font-size: 40px"></i>
    </div>
    <div v-else>
      <div :class="studentInfo?.bgStatus ? studentInfo?.bgStatus : 'bg-gradient__info'"
           class="d-flex align-items-center justify-content-between" style="padding: 8px 30px;">
        <span style="font-weight: 600; font-size: 16px">{{ studentSelected?.name }}</span>
        <span :class="handleClassStatus">{{ studentInfo?.status === ''?'Chưa nộp': studentInfo?.status?? 'Chưa nộp' }}</span>

      </div>
      <el-alert
          v-if="studentSelected?.isFraud"
          title="Học viên đã bị đánh dấu gian lận"
          type="error"
          show-icon
          :closable="false"
          style="margin: 12px 30px 0"
      />
      <el-alert
          v-else-if="studentSelected?.isSuspected"
          title="Học viên đang bị nghi ngờ gian lận"
          type="warning"
          show-icon
          :closable="false"
          style="margin: 12px 30px 0"
      />
      <div class="container-info">
        <div class="container-point">
          <div>Nghe: <span style="font-weight: 600">
        {{ studentInfo?.listening }}
      </span></div>
          <div>Đọc: <span style="font-weight: 600">
        {{ studentInfo?.reading }}
      </span></div>
          <div>Nói: <span style="font-weight: 600">
        {{ isSuspectedHold ? 'Đang chờ xử lý' : studentInfo?.speaking }}
      </span></div>
          <div>Viết: <span style="font-weight: 600">
        {{ isSuspectedHold ? 'Đang chờ xử lý' : studentInfo?.writing }}
      </span></div>
          <div>Nộp bài lúc: <span style="font-weight: 600">
        {{ studentInfo?.submittedAt }}
      </span></div>
          <div>Người nộp: <span style="font-weight: 600">
        {{ studentInfo?.name }}
      </span></div>
          <div>Chấm bài lúc: <span style="font-weight: 600">
        {{ studentInfo?.gradedAt ?? '' }}
      </span></div>
        </div>
        <hr/>
        <div>
          <p>CHI TIẾT BÀI LÀM CỦA HỌC VIÊN</p>
          <SpeakingSkill :data="speakingData"></SpeakingSkill>
          <WritingSkill :data="writingData" :isImport="isImport" :isOffline="isOffline"></WritingSkill>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {StudentSkillModel} from "@/view/pages/marking-exam/model/taskPersonal";
import {
  GET_ANSWER_DATA_STUDENT,
  GET_EXAM_STUDENT_INFO,
  IMPORT_READING_AND_WRITING_EXAM_STUDENT
} from "@/core/services/store/marking/marking.module";
import SpeakingSkill from "@/view/pages/marking-exam/PersonalTaskList/SpeakingSkill.vue";
import WritingSkill from "@/view/pages/marking-exam/PersonalTaskList/WritingSkill.vue";

export default {
  name: 'ImportSkill',
  components: {WritingSkill, SpeakingSkill},
  data() {
    return {
      studentInfo: null,
      loading: false,
      skill: [],
      files: [],
      loadingSubmit: false,
      FILE_TYPE: {
        AUDIO: 'audio',
        IMAGE: 'image'
      },
      speakingData: null,
      writingData: null,
      isImport: false,
      isOffline: false
    }
  },
  props: {
    studentSelected: {
      type: Object,
      required: true,
      default: {}
    }
  },
  computed: {
    handleClassStatus(){
      return this.studentInfo?.status?this.studentInfo?.status === 'Cần chấm' ? 'badge badge-warning' : 'badge badge-success' : 'badge badge-secondary'
    },
    // Nghi ngờ (chưa xác nhận gian lận): giữ điểm Nói/Viết chờ admin xử lý. Đã xác nhận
    // gian lận (isFraud) thì điểm đã về 0 nên hiện bình thường.
    isSuspectedHold(){
      return this.studentSelected?.isSuspected && !this.studentSelected?.isFraud
    }
  },
  watch: {
    studentSelected: {
      handler(val) {
        if (!val) return;
        this.getAnswerDataStudent()
        this.getStudentInfo();
      },
      deep: true
    }
  },
  async mounted() {
    if (this.studentSelected.id) {
     await this.getAnswerDataStudent()
      this.getStudentInfo();
    }
  },
  methods: {
    getStudentInfo() {
      this.loading = true
      const payload = {
        marking_exam_retake_id: this.studentSelected.id
      }
      this.$store.dispatch(GET_EXAM_STUDENT_INFO, payload).then(res => {
        if (!res.error) {
          this.studentInfo = new StudentSkillModel(res.data)
        }
      }).catch(e => {
        this.studentInfo = null
        console.log(e.data.message ?? '')
      }).finally(() => {
        this.loading = false
      })
    },
    async getAnswerDataStudent() {
      try {
        this.loading = true
        this.speakingData = null
        this.writingData = null
        const payload = {
          marking_retake_id: this.studentSelected.id
        }
        const res = await this.$store.dispatch(GET_ANSWER_DATA_STUDENT, payload)
        this.speakingData = res?.data?.skills?.speaking
        this.writingData = res?.data?.skills?.writing
        this.isImport = res?.data?.type ===1
        this.isOffline = res?.data?.exam_form ===2

      } catch (e) {
        this.speakingData = null
        this.writingData = null
        this.isImport = false

      } finally {
        this.loading = false
      }

    },
  }
}
</script>

<style scoped>
.container-content {
  position: relative;
  border-radius: 8px;
  border: 1px solid gray;
  width: 100%;
  overflow-y: auto; height: 600px;
}

.container-info {
  padding: 15px 30px;
}

.container-point {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 30px;
}
.image-import:hover i {
  color: red;
}

</style>